import { Component, signal, output, inject, input, effect, computed } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AddNewValue } from '../add-new-value/add-new-value';
import { AttributesService } from '../../../../services/productAttributes/productAttributes.service';
import { ProductAttributeValueResponse } from '../../../../services/productAttributes/productAttributes.model';

@Component({
  selector: 'app-add-attribute-form',
  standalone: true,
  imports: [FormsModule, AddNewValue],
  templateUrl: './add-attribute-form.html',
    styleUrl: './add-attribute-form.scss',
})
export class AddAttributeForm {
  private attributesService = inject(AttributesService);
  
  productId = input<number>(); 
  existingKeys = input<string[]>([]);
  editData = input<{ titleEn: string; titleAr: string | null; index: number } | null>(null);

  onAdd = output<{ titleEn: string; titleAr: string }>();
  onEdit = output<{ titleEn: string; titleAr: string; index: number }>();
  onCloseForm = output<void>();

  newAttributeKeyEn = signal("");
  newAttributeKeyAr = signal<string | null>(null);
  isSaving = signal(false);
  arTouched = signal(false);
  enTouched = signal(false);

  arErrors = computed(() => {
    const val = this.newAttributeKeyAr() ?? '';
    return {
      required: val.trim() === '',
      maxlength: val.length > 100,
      arabicOnly: !/^[\u0600-\u06FF0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(val),
    };
  });

  enErrors = computed(() => {
    const val = this.newAttributeKeyEn();
    return {
      maxlength: val.length > 100,
      englishOnly: !/^[a-zA-Z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(val),
    };
  });

  isInvalid = computed(() => {
    const ar = this.arErrors();
    const en = this.enErrors();
    return ar.required || ar.maxlength || ar.arabicOnly || en.maxlength || en.englishOnly;
  });

  constructor() {
    effect(() => {
      const data = this.editData();
      if (data) {
        this.newAttributeKeyEn.set(data.titleEn);
        this.newAttributeKeyAr.set(data.titleAr);
      } else {
        this.newAttributeKeyEn.set("");
        this.newAttributeKeyAr.set(null);
      }
    });
  }

  submitForm() {
    this.arTouched.set(true);
    this.enTouched.set(true);
    if (this.isInvalid()) return;
    const data = {
      titleEn: this.newAttributeKeyEn().trim(),
      titleAr: this.newAttributeKeyAr()!.trim()
    };

    if (this.editData()) {
      this.onEdit.emit({ ...data, index: this.editData()!.index });
    } else {
      this.onAdd.emit(data);
    }
  }

  goBack() {
    this.onCloseForm.emit();
  }
}